<template>

    <Page>

        <ImageAndText 
            src="/SuccessLeavesATrail/airline-example.png"
            animation="slide-up"
            flip
            floor-shadow
            border>

            <h2 class="mb-4">Airlines make more money selling miles than seats!</h2>
            <p class="font-normal text-white/80">
                When the bottom fell out of air travel, loyalty programs 
                stood out for their resilience. Although people had stopped 
                flying (COVID), they continued to spend with program partners, 
                specifically the co-branded credit cards.
            </p>

        </ImageAndText>

    </Page>

</template>